import React from 'react';

const IMG = {
  gear: 'https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?q=80&w=2670&auto=format&fit=crop',
};

const AboutBanner: React.FC = () => (
  <section className="relative h-96 overflow-hidden">
    <img src={IMG.gear} alt="Advanced medical infusion technology" className="w-full h-full object-cover" />
    <div className="absolute inset-0 bg-primary/80 flex items-center">
      <div className="container-main">
        <div className="max-w-xl">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-6">We Stay Current with the Latest Medical Technologies</h2>
          <p className="text-white/80 leading-relaxed text-lg">
            Continually updating our product range with cutting-edge medical technologies to provide
            the best solutions to hospitals and laboratories across sub-Saharan Africa.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default AboutBanner;
